import styled from '@emotion/styled'
import { tokens } from '@news-mono/design-tokens'
import { breakpoint, calcRem, getComponentTheme } from '../../../__styling'

export const SearchFiltersContainer = styled.div({
    display: 'flex',
    flexDirection: 'column',
    padding: calcRem(80, 0, 40, 0),
    [breakpoint('lg')]: {
        gap: calcRem(40),
    },
})

export const FiltersWrapper = styled.div({
    display: 'none',
    [breakpoint('lg')]: {
        display: 'flex',
        flexDirection: 'column',
        gap: calcRem(16),
    },
})

export const Divider = styled.div(({ theme }) => {
    const color =
        theme.kind === 'sevennews'
            ? tokens.sevennews.colors.palette.alto
            : getComponentTheme(theme, 'taglinkNav').divider.color

    return {
        display: 'none',
        marginTop: calcRem(40),

        [breakpoint('lg')]: {
            display: 'flex',
            height: calcRem(1),
            background: color,
        },
    }
})

export const TrailingContent = styled.div({
    display: 'none',

    [breakpoint('lg')]: {
        display: 'flex',
        flexDirection: 'column',
        gap: calcRem(24),
    },
})

export const StyledHeader = styled.div(({ theme }) => ({
    display: 'block',
    width: '100%',
    color: theme.kind === 'sevennews' ? theme.colors.text.heading : undefined,
}))
